var defaultLabels = {
  loading: 'Loading',
  scrollToTop: 'Scroll To Top'
};

export { defaultLabels as default };
